import { d as a } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var i = {
  name: "tzl",
  weekdays: "Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),
  months: "Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split("_"),
  weekStart: 1,
  weekdaysShort: "Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),
  monthsShort: "Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
  weekdaysMin: "Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "HH.mm",
    LTS: "HH.mm.ss",
    L: "DD.MM.YYYY",
    LL: "D. MMMM [dallas] YYYY",
    LLL: "D. MMMM [dallas] YYYY HH.mm",
    LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm"
  }
};
a.locale(i, null, !0);
export {
  i as default
};
